export const cutTextLength = (txt,len = 90) => {
  return `${String(txt).slice(0,len)}...`
}
